<template>
  <div>
    <div class="help-box" v-if="selectedBox !== ''">
      <component v-bind:is="selectedBox" v-bind:select-style="selectStyle"></component>
    </div>
  </div>
</template>

<script>
import WebpageHelp from '@/components/generator-example/webpage'
import JournalHelp from '@/components/generator-example/article-journal'
import BookHelp from '@/components/generator-example/book'

export default {
  name: "GeneratorExample",
  components: {
    "webpage_help" : WebpageHelp,
    "article-journal_help" : JournalHelp,
    "book_help" : BookHelp
  },
  props: ["selectStyle", "selectSource"],
  data: function () {
    return {
      "selectedBox" : "", // BOX
    }
  },
  methods: {
    change_help_box() {
      if( this.selectStyle && this.selectSource )
        this.selectedBox = `${this.selectSource}_help`;
      else
        this.selectedBox = '';
    }
  },
  mounted() {
    this.change_help_box();
  },
  watch: {
    selectSource: function (val) {
      this.change_help_box();
    },
    selectStyle: function (val) {
      this.change_help_box();
    },
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/generator-example/GeneratorExample.vue